module.exports = __webpack_public_path__ + "static/media/business-and-trade-gray.9d42c43b.svg";